import { CommonModule } from '@angular/common';
import { Component, Renderer2 } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { HeroBannerComponent } from '../Components/hero-banner/hero-banner.component';

@Component({
  selector: 'app-aboutpage',
  standalone: true,
  imports: [CommonModule, HeroBannerComponent],
  templateUrl: './aboutpage.component.html',
  styleUrl: './aboutpage.component.scss',
})
export class AboutpageComponent {
  imgPath = '../../assets/hi-res/hero-about.png';
}
